export { default as ImagePromotion } from './ImagePromotion';
export { type ImagePromotionProps, default as useImagePromotion } from './useImagePromotion';
